import { addDays } from '@/utils/shared'

export const ModelInvoice = () => {
  return {
    id: '',
    invoiceNumber: '',
    rfqid: '',
    po: '',
    invoiceDate: new Date(),
    dueDate: addDays(new Date(), 30),
    invoiceTypeID: null,
    invoiceSourceID: null,
    countryOriginID: null,
    vatid: null,
    totalPackages: null,
    bankFees: 0,
    aogCharges: 0,
    awb: '',
    shippingCharges: 0,
    shipDate: null,
    flightDetails: '',
    remark: ''
  }
}

export const ModelInvoiceDetail = () => {
  return {
    id: null,
    partID: null,
    partSN: null,
    qty: 1,
    conditionID: null,
    price: null,
    currencyID: null,
    tagInfoCompanyID: null,
    tagDate: null,
    releaseID: null,
    remarks: null,
    chosen: false
  }
}
